import React, { ReactChild, ReactNode } from 'react';
import './custom-scrollable-wrapper.scss';

export interface CustomScrollableWrapperProps {
  heading?: ReactChild;
  children?: ReactNode;
  /* Height of the container to make the content as scollable */
  containerHeight?: string;
  testId?: string;
}

export const CustomScrollableWrapper: React.FC<CustomScrollableWrapperProps> = ({
  containerHeight,
  testId,
  children,
  heading,
}) => {
  return (
    <>
      {heading ? typeof heading !== 'string' ? heading : <div style={{ marginBottom: '8px' }}>{heading}</div> : null}
      <div
        data-testid={'custom-scrollable-wrapper' + (testId ? `-${testId}` : '')}
        className="custom-scrollable-container"
        style={{
          maxHeight: containerHeight ? containerHeight : '360px',
        }}
      >
        {children}
      </div>
    </>
  );
};
